const tray = {
  title: "מגש עבודה",
  pinToTray: "הצמד למגש",
  unpinFromTray: "הסר מהמגש",
  clearAll: "נקה הכל",
  emptyTray: "המגש ריק — הצמד עמודים להמשך עבודה",
  splitLeft: "פצל שמאלה",
  splitRight: "פצל ימינה",
  closeSplit: "סגור פיצול",
  splitActive: "פיצול מסך פעיל",
} as const;
export default tray;
